import React, { useEffect, useState, useContext } from 'react';
import quickReportStyle from './QuickReport.style';
import { useSelector, useDispatch } from 'react-redux';
import { Box, Typography, List, ListItem, ListItemText } from '@material-ui/core';
import {
	FILTER_CONDITION_LABELS,
	CANNED_REPORT_LIST,
	DATA_IN_USE,
	MORE_DATA_AVAILABLE,
	USE_THE_DATASET,
	DATA_FOR_CHARTER_ONLY,
	ITEM_ACCESS_TYPE_FIELD,
	GENERAL_CANNED_REPORT_LIST,
	SHOW_AS_CANNED_REPORT,
	TENDER_ANALYSIS_LIST,
	ECOMM_INSTOCK_LIST,
	PERSONA,
	ATTRIBS_LOWERCASE,
	DATE_KEY
} from 'constants/constant';
import {
	setSelectedList,
	setFilterList,
	clearPreview,
	resetDraft,
	setPrevFilterList,
	saveItemShareStatus
} from 'components/Preview/Preview.actions';
import moment from 'moment';
import FooterButton from './FooterButton.component';
import { UserPortalContext } from 'context/appcontext';
import { build } from 'helper/build';
import { buildPreviewSelectedList } from 'components/Preview/Preview.utils';
import { createFolders } from 'components/Preview/Preview.utils';
import { isCalFamily } from 'components/Preview/filter/FilterCondition';
import { FEATURES } from 'helper/basicFeatureFlag';
import { deepClone } from 'helper/helper';
import { resetSubTempates } from '../Template.actions';
import AddIcon from '@material-ui/icons/Add';
import { useNavigate } from 'react-router-dom';
import { handleBuildReport } from './QuickReport.utils';
import { trackEventInfo } from 'helper/analytics';
import { EVENTS, PAGE_ID, ACTION_ON } from 'constants/tracker';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import { getTmplName } from 'helper/utils';
import { SHIP_TO_ZIP_LIST } from 'constants/constant';
import { getStartAndEndDates } from 'helper/dateRange';
import { getFuzzyOptions } from 'helper/utils';

const dateFormat = 'MM/DD/YYYY';

const QuickReportDetails = (props) => {
	const { show, isTooltipCheck, setIsTooltipCheck, selectedTemplateData, subTemplateName } = props;
	const classes = quickReportStyle();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [parsedData, setParsedData] = useState([]);
	const [showTooltip, setShowTooltip] = useState(false);
	const [showDimensionsForCannedReport, setShowDimensionsForCannedReport] = useState(false);
	const subTempDetails = useSelector((state) => state.templateReducer.subTempDetails);
	const sbuDBTechNames = useSelector((state) => state.templateReducer.sbuDimDBTechName);
	const sbuDepartments = useSelector((state) => state.templateReducer.sbuDepartments);
	const selectedView = useSelector((state) => state.templateReducer.selectedView);
	const selectedTemplate = useSelector((state) => state.templateReducer.selectedTemplate);
	const templateData = useSelector((state) => state.templateReducer.templateData);
	const cannedReportData = useSelector((state) => state.templateReducer.cannedReportData);
	const filterList = useSelector((state) => state.previewReducer.filterList);
	const defaultSelectedList = useSelector((state) => state.previewReducer.selectedList);
	const itemShareStatus = useSelector((state) => state.previewReducer.itemShareStatus);
	const calendarRollDim = useSelector((state) => state.dashboardReducer.calendarRollDim);
	const portalUserContext = useContext(UserPortalContext);
	const { userDetails, customerType, isStudent } = portalUserContext;
	const { userPersona, blackOut } = userDetails?.result;
	const { PREVIEW_ATTRIBUTE_ONLY: previewAttributeOnly } = FEATURES[customerType].TEMPLATE_PAGE;
	let data = {
		dimensions: [],
		measures: [],
		selectedAttribs: [],
		folderNames: []
	};

	const getDfltFilterForCanned = (tData) => {
		const selectedTemplateId = Number(tData.templateId);
		const dfltFilter = [];
		let temp;
		if (TENDER_ANALYSIS_LIST.includes(selectedTemplateId)) {
			const parent = tData?.time[0]?.businessName;
			temp = tData?.time[0]?.subAttributes.find((el) => el.businessName === 'Week');
			let filter = {
				...temp,
				parent: parent,
				filter: {
					condition: FILTER_CONDITION_LABELS.WMT_LAST_13_WEEKS,
					value: ['13 weeks ago for 13 weeks']
				}
			};
			const field = build(filter, selectedView, userPersona, false, selectedTemplate);
			filter.field = field;
			dfltFilter.push(filter);
		}
		if (SHIP_TO_ZIP_LIST.includes(selectedTemplateId)) {
			const parent = tData?.time[0]?.businessName;
			temp = tData?.time[0]?.subAttributes.find((el) => el.businessName === 'Quarter');
			let filter = {
				...temp,
				parent: parent,
				filter: {
					condition: FILTER_CONDITION_LABELS.WMT_QUARTER_TO_DATE,
					value: [0, 0]
				}
			};
			const field = build(filter, selectedView, userPersona, false, selectedTemplate);
			filter.field = field;
			dfltFilter.push(filter);
		}
		if (ECOMM_INSTOCK_LIST.includes(selectedTemplateId)) {
			const parent = tData?.time[0]?.businessName;
			const isWMTCal = parent?.substring(0, 3) === 'Wal';
			temp = tData?.time[0]?.subAttributes.find((el) => el.businessName === DATE_KEY);
			const filteredFuzzyOption = getStartAndEndDates(
				FILTER_CONDITION_LABELS.YESTERDAY,
				getFuzzyOptions(),
				isWMTCal,
				calendarRollDim
			);
			let filter = {
				...temp,
				parent: parent,
				filter: {
					condition: FILTER_CONDITION_LABELS.YESTERDAY,
					value: [FILTER_CONDITION_LABELS.YESTERDAY],
					extraValue: [
						moment(filteredFuzzyOption?.weekStartDate).format(dateFormat),
						moment(filteredFuzzyOption?.weekEndDate).format(dateFormat)
					]
				}
			};
			const field = build(filter, selectedView, userPersona, false, selectedTemplate);
			filter.field = field;
			dfltFilter.push(filter);
		}
		return dfltFilter;
	};

	useEffect(() => {
		setParsedData([]);
		setShowDimensionsForCannedReport(GENERAL_CANNED_REPORT_LIST.includes(Number(selectedTemplate)));
		// Show only Time, Dimension, Metrics for disabled templates
		if (!SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate)) && previewAttributeOnly) {
			data = {
				time: selectedTemplateData.time,
				dimensions: selectedTemplateData.dimensions,
				measures: selectedTemplateData.measures,
				folderNames: selectedTemplateData.folderNames
			};
			const hierarchyFolders = createFolders([data], [], false, isStudent, previewAttributeOnly);
			setParsedData(hierarchyFolders);
			return;
		}

		/**
		 * Reseting filter
		 */
		dispatch(setSelectedList([]));
		dispatch(setFilterList([]));
		if (SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate))) {
			const selectedCannedData = cannedReportData.filter(
				(item) => item.templateName === getTmplName(Number(selectedTemplate))
			);
			data = {
				dimensions: selectedCannedData[0].dimensions.map((item) => {
					return {
						...item,
						parent: ATTRIBS_LOWERCASE.dimensions,
						filter: { condition: '', value: [] }
					};
				}),
				measures: selectedCannedData[0].measures.map((item) => {
					return { ...item, parent: ATTRIBS_LOWERCASE.measures };
				}),
				folderNames: selectedCannedData[0].folderNames
			};

			/**
			 * Add SBU filters as default filters for all non-blackOut merchants.
			 */
			if (userPersona === PERSONA.MERCHANT && !blackOut) {
				if (
					!data.dimensions.some(
						(el) => sbuDBTechNames.includes(el.dbtechnicalName) && el.filter.value.length > 0
					)
				) {
					const index = data.dimensions.findIndex((dim) =>
						sbuDBTechNames.includes(dim.dbtechnicalName)
					);
					const SBUdimension = data.dimensions.filter((dim) =>
						sbuDBTechNames.includes(dim.dbtechnicalName)
					);
					const SBUDfltCondition = FILTER_CONDITION_LABELS.IS_EQUAL_TO;
					let sbuFilter = {};
					SBUdimension.forEach((dim) => {
						sbuFilter = {
							...dim,
							parent: ATTRIBS_LOWERCASE.dimensions,
							filter: {
								condition: SBUDfltCondition,
								value: sbuDepartments.map((dept) => dept.deptNum)
							}
						};
						const field = build(sbuFilter, selectedView, userPersona);
						sbuFilter.field = field;
						data.dimensions[index].filter = sbuFilter.filter;
						data.dimensions[index].field = sbuFilter.field;
					});
				}
			}

			if (GENERAL_CANNED_REPORT_LIST.includes(Number(selectedTemplate))) {
				data.dimensions = data.dimensions.filter((item) => item.preSelected === true);
			}

			const hierarchyFolders = createFolders([data], [], true, isStudent, previewAttributeOnly);
			setParsedData(hierarchyFolders);
			if (GENERAL_CANNED_REPORT_LIST.includes(Number(selectedTemplate))) {
				// Future Valid Item/Store Note: preSelectedOrder determines the order of columns that are pre-selected by default.
				// preSelectedOrder is not present for all columns in canned report list, therefore, we don't meddle
				// with the order of columns in those cases.
				const preSelectedDimensionList = data.dimensions
					.filter((item) => item.preSelected === true)
					?.sort((a, b) => {
						if (a['preSelectedOrder'] === undefined || b['preSelectedOrder'] === undefined) {
							return 0;
						}
						return a.preSelectedOrder - b.preSelectedOrder;
					});
				const preSelectedMeasureList = data.measures
					.filter((item) => item.preSelected === true)
					?.sort((a, b) => {
						if (a['preSelectedOrder'] === undefined || b['preSelectedOrder'] === undefined) {
							return 0;
						}
						return a.preSelectedOrder - b.preSelectedOrder;
					});
				const preSelectedList = [...preSelectedDimensionList, ...preSelectedMeasureList];
				if (selectedCannedData[0].time) {
					const preSelectedCalendar = selectedCannedData[0].time.find((calendar) => {
						return calendar.subAttributes.some((_o) => _o.preSelected === true);
					});
					const preSelectTime = preSelectedCalendar?.subAttributes?.find(
						(item) => item.preSelected === true
					);
					if (preSelectTime) {
						preSelectTime.parent = preSelectedCalendar?.businessName;
						preSelectedList.push(preSelectTime);
					}
				}
				dispatch(setSelectedList(preSelectedList));
			} else {
				dispatch(setSelectedList(data.measures));
			}
			if (
				[...TENDER_ANALYSIS_LIST, ...SHIP_TO_ZIP_LIST, ...ECOMM_INSTOCK_LIST].includes(
					Number(selectedTemplate)
				)
			) {
				let dfltFilterList = getDfltFilterForCanned(selectedTemplateData);
				dispatch(setFilterList(dfltFilterList));
				dispatch(setPrevFilterList(dfltFilterList));
			} else {
				const filterWithValues = data.dimensions.filter(
					(item) => item.dataType !== 'time' && item.filter.condition !== ''
				);
				dispatch(setFilterList(filterWithValues));
			}
		} else if (subTempDetails !== null) {
			const { filtersWithValue, runQueryRequestObject } = subTempDetails;

			let requestObj = deepClone(runQueryRequestObject);
			let filterValue = deepClone(filtersWithValue);

			requestObj?.fields.forEach((item) => {
				let attribName = item.split('.')[1];

				/** Intentionally executing before checking itemshare statue because from the selection list
				 * don't want to remove attribute 'Item Access Type'
				 */
				if (!itemShareStatus.curr && attribName === ITEM_ACCESS_TYPE_FIELD) {
					attribName = '';
				}
				const sa = filterValue.filter((item) => item.technicalName === attribName);

				const dim = selectedTemplateData.dimensions.filter(
					(item) => item.technicalName === attribName
				);
				const msure = selectedTemplateData.measures.filter(
					(item) => item.technicalName === attribName
				);

				const dt = {
					dimensions: [...data.dimensions, ...dim],
					measures: [...data.measures, ...msure],
					selectedAttribs: [...data.selectedAttribs, ...sa]
				};

				data = {
					dimensions: dt.dimensions.map((item) => {
						return { ...item, parent: ATTRIBS_LOWERCASE.dimensions };
					}),
					measures: dt.measures.map((item) => {
						return { ...item, parent: ATTRIBS_LOWERCASE.measures };
					}),
					selectedAttribs: dt.selectedAttribs.map((item) => {
						return { ...item };
					}),
					folderNames: selectedTemplateData.folderNames
				};
			});

			const hierarchyFolders = createFolders([data], [], false, isStudent);

			const details = {
				columns: data.selectedAttribs.map((item) => item.businessName),
				...subTempDetails
			};

			const selectedList = buildPreviewSelectedList(details, templateData, selectedTemplate);
			/**
			 * Add SBU filters as default filters for all non-blackOut merchants.
			 */
			if (userPersona === PERSONA.MERCHANT && !blackOut) {
				if (
					!filterValue.some(
						(el) => sbuDBTechNames.includes(el.dbtechnicalName) && el.filter.value.length > 0
					)
				) {
					const SBUdimension = selectedTemplateData.dimensions.filter((dim) =>
						sbuDBTechNames.includes(dim.dbtechnicalName)
					);
					const SBUDfltCondition = FILTER_CONDITION_LABELS.IS_EQUAL_TO;
					SBUdimension.forEach((dim) => {
						const sbuFilter = {
							...dim,
							parent: ATTRIBS_LOWERCASE.dimensions,
							filter: {
								condition: SBUDfltCondition,
								value: sbuDepartments.map((dept) => dept.deptNum)
							}
						};
						const field = build(sbuFilter, selectedView, userPersona);
						sbuFilter.field = field;
						filterValue.push(sbuFilter);
					});
				}
			}

			/**
			 * below code is to retain filter when user navigate from "filter" drawer to "Data in use" drawer.
			 */
			filterList.forEach((item) => {
				if (item.field) {
					const obj = filterValue.filter((filter) => filter.businessName === item.businessName)[0];
					if (obj) {
						obj.field = item.field;
						obj.filter = item.filter;
					}
				}
			});

			const filtersWithValueWOTime = filterValue.filter(
				(item) => item.dataType !== 'time' && item.filter.condition !== ''
			);

			setParsedData(hierarchyFolders);
			dispatch(setSelectedList(selectedList));
			dispatch(setFilterList(filtersWithValueWOTime));
		}
	}, [subTempDetails, itemShareStatus, selectedTemplateData]);

	const handleTooltip = () => {
		setTimeout(() => {
			setIsTooltipCheck(false);
			setShowTooltip(show);
		}, 500);
	};

	const GenerateList = (val, id, parentName = '') => {
		return (
			<ListItem
				className={classes.listItem}
				onClick={() => handleTooltip()}
				key={
					val.technicalName
						? `${val.technicalName}_${id}`
						: `${val.businessName}_${parentName}_${id}`
				}
				disabled={val.isDisabled || (isStudent && val?.isDisabledForStudent)}>
				<ListItemText className={classes.listItemRow}>
					<Typography className={classes.listItemText}>{val.businessName}</Typography>
				</ListItemText>
			</ListItem>
		);
	};

	const buildReport = () => {
		trackEventInfo({
			type: EVENTS.CLICK,
			actionOn: `${ACTION_ON.BUILD_REPORT_BUTTON} ${selectedTemplateData.templateName}`,
			location: PAGE_ID.TEMPLATES
		});

		const result = templateData.filter(
			(item) => item.templateName === getTmplName(selectedTemplate)
		);

		const dispatchFilterList = (list) => {
			dispatch(setFilterList(list));
			dispatch(setPrevFilterList(list));
		};

		const dispatchSelectedList = (list) => {
			dispatch(setSelectedList(list));
		};

		handleBuildReport(
			selectedTemplate,
			result,
			userPersona,
			blackOut,
			sbuDBTechNames,
			sbuDepartments,
			selectedView,
			dispatchFilterList,
			dispatchSelectedList
		);
		dispatch(clearPreview([]));
		dispatch(resetDraft());
		dispatch(saveItemShareStatus({ prev: false, curr: false }));
		navigate('/preview');
	};

	/**
	 * For Basic user,
	 * in the case of disabled templates allow only previewing the attributes
	 */
	let footerButton = (
		<FooterButton
			isTooltipCheck={isTooltipCheck}
			setIsTooltipCheck={setIsTooltipCheck}
			show={show}
			showTooltip={showTooltip}
			selectedTemplateData={selectedTemplateData}
			subTemplateName={subTemplateName}
		/>
	);
	let heightDiff = '200px';
	if (!SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate)) && previewAttributeOnly) {
		footerButton = (
			<Box className={classes.buttonContainer}>
				<Box
					id="build-report"
					onClick={() => {
						dispatch(resetSubTempates());
						buildReport();
					}}
					className={classes.scratch}>
					<AddIcon fontSize="medium" className={classes.addIcon} />
					<Box>
						<span className={classes.normalFont}>{USE_THE_DATASET}</span>
					</Box>
				</Box>
			</Box>
		);
	}
	if (selectedTemplateData?.isDisabled && previewAttributeOnly) {
		heightDiff = '72px';
		footerButton = null;
	}

	const getSelectedListCount = () => {
		return defaultSelectedList.filter((filter) => !isCalFamily(filter)).length;
	};

	const shouldShowFolder = (item) => {
		if (CANNED_REPORT_LIST.includes(Number(selectedTemplate))) {
			if (item.measures?.length > 0) {
				return true;
			}
			if (showDimensionsForCannedReport && item.dimensions?.length > 0) {
				return true;
			}
			return false;
		}
		return item.periods?.length > 0 || item.dimensions?.length > 0 || item.measures?.length > 0;
	};

	return (
		<Box>
			<Box style={{ height: `calc(100vh - ${heightDiff})` }}>
				{!previewAttributeOnly && (
					<>
						<Box className={classes.subHeader}>
							<span className={classes.dataInUse}>{DATA_IN_USE}</span>
							<span className={classes.subHeaderCount}>{getSelectedListCount()}</span>
						</Box>

						<Box className={classes.subHeader}>
							<span className={classes.moreDataText}>{MORE_DATA_AVAILABLE}</span>
						</Box>
					</>
				)}
				{parsedData.map((item) => {
					return (
						shouldShowFolder(item) && (
							<Box className={classes.listContainer} key={item.name}>
								<Box className={classes.subHeader}>
									<span className={classes.subHeaderText}>{item.name}</span>
								</Box>
								<List className={classes.lists}>
									{previewAttributeOnly &&
										item.periods?.map((val, id) => {
											return (
												<>
													<Typography className={`${classes.subHeader} ${classes.subHeaderText}`}>
														{val.businessName}
													</Typography>
													{val.subAttributes.map((attr) =>
														GenerateList(attr, id, val.businessName)
													)}
												</>
											);
										})}
									{item.dimensions?.map((val, id) => {
										return GenerateList(val, id);
									})}
									{item.measures?.map((val, id) => {
										return GenerateList(val, id);
									})}
								</List>
							</Box>
						)
					);
				})}
				{!SHOW_AS_CANNED_REPORT.includes(Number(selectedTemplate)) &&
					!selectedTemplateData?.isDisabled &&
					previewAttributeOnly && (
						<>
							<Box className={classes.subHeader} style={{ marginTop: '16px' }}>
								<span className={classes.subHeaderTextCharterOnly}>
									{DATA_FOR_CHARTER_ONLY}
									<LockOutlinedIcon className={classes.subHeaderLockIcon} />
								</span>
							</Box>

							{parsedData.map((item) => {
								return (
									<>
										{item.disabledDim?.map((val, id) => {
											return GenerateList(val, id);
										})}
										{item.disabledMsr?.map((val, id) => {
											return GenerateList(val, id);
										})}
									</>
								);
							})}
						</>
					)}
			</Box>
			{/* Footer Button */}
			{footerButton}
		</Box>
	);
};

export default QuickReportDetails;
